import { PitchbookComponent } from "@/features"

export const PitchbookPage = () => {
  return <PitchbookComponent />
}
